<template>
  <NavigationBar/>
  <div
      class="pt-16 min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-purple-100 to-pink-200 p-4 animate-gradient">
    <form
        class="w-full max-w-2xl bg-white/80 backdrop-blur-2xl shadow-2xl rounded-3xl p-6 sm:p-10 space-y-6 border border-white/50 animate-fade-in-up animate-float transition-all duration-400 hover:scale-[1.02] hover:shadow-3xl"
    >
      <h2 class="text-3xl font-extrabold text-gray-800 mb-2 text-center tracking-tight drop-shadow-sm animate-bounce-in">
        <span class="inline-block bg-gradient-to-r from-blue-500 to-purple-400 bg-clip-text text-transparent">Create Enquiry</span>
      </h2>
      <!-- Customer Type -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">Customer Name:</label>
        <div class="flex gap-4">
          <label class="flex items-center gap-2 cursor-pointer">
            <input
                type="radio"
                value="Old"
                id="old_radio"
                name="client_radio"
                v-model="customerType"
                class="accent-blue-500 transition"
            />
            <span>Old</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input
                type="radio"
                value="New"
                id="new_radio"
                name="client_radio"
                v-model="customerType"
                class="accent-blue-500 transition"
            />
            <span>New</span>
          </label>
        </div>

        <!-- Existing clients dropdown -->
        <select
            v-if="customerType === 'Old'"
            v-model="selectedExistingClient"
            @change="CustomerName = selectedExistingClient"
            class="flex-1 border border-gray-300 outline-none rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 transition"
        >
          <option value="" disabled selected>Select existing client</option>
          <option v-for="client in uniqueClientNames" :key="client" :value="client">
            {{ client }}
          </option>
        </select>

        <!-- New client input -->
        <input
            v-else
            type="text"
            placeholder="Enter Name"
            v-model="CustomerName"
            required
            class="flex-1 border border-gray-300 outline-none rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 transition"
        />
      </div>
      <!-- Customer Name -->
      <!-- Delivery Address -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">Delivery Address:</label>
        <textarea v-model="DeliveryAddress" rows="2"
                  class="flex-1 outline-none border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-pink-400 transition resize-none"
                  placeholder="Delivery Address"></textarea>
      </div>
      <!-- Billing Address -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">Billing Address:</label>
        <textarea v-model="BillingAddress" rows="2"
                  class="flex-1 outline-none border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-pink-400 transition resize-none"
                  placeholder="Billing Address"></textarea>
      </div>
      <!-- PO Date -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">PO Date:</label>
        <input type="date" v-model="PODate"
               class="flex-1 outline-none border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 transition"/>
      </div>
      <!-- Payment Received -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">Payment Received:</label>
        <div class="flex gap-4">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" value="Yes" id="pay_yes" v-model="PaymentRecievedType" name="pay_radio"
                   class="accent-green-500 transition"/>
            <span>Yes</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" value="No" id="pay_no" v-model="PaymentRecievedType" name="pay_radio"
                   class="accent-red-500 transition"/>
            <span>No</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" value="Partial" v-model="PaymentRecievedType" id="pay_partial" name="pay_radio"
                   class="accent-yellow-500 transition"/>
            <span>Partial</span>
          </label>
        </div>
        <div v-if="PaymentRecievedType === 'Partial'" class="flex items-center gap-2 animate-fade-in-up">
          <label for="percent" class="text-gray-600">Percentage</label>
          <input type="text" id="percent" v-model="payment_percet"
                 class="border outline-none border-gray-300 rounded-lg px-2 py-1 focus:ring-2 focus:ring-yellow-400 transition"
                 required/>
        </div>
      </div>
      <!-- Kit and Quantity Table -->
      <div class="space-y-2">
        <label class="block font-semibold text-gray-700 mb-1">Kit and Quantity</label>
        <div class="overflow-x-auto rounded-xl shadow">
          <table class="min-w-full text-center bg-white/70 rounded-xl animate-fade-in-up">
            <thead>
            <tr class="bg-gradient-to-r from-blue-400 to-purple-300 text-white">
              <th class="py-2 px-4 rounded-tl-xl">S.N</th>
              <th class="py-2 px-4">Name</th>
              <th class="py-2 px-4 rounded-tr-xl">Quantity</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="n in 8" :key="n" class="hover:bg-blue-50 transition">
              <td class="py-2 px-4 font-bold text-blue-600">{{ n }}</td>
              <td class="py-2 px-4 font-medium text-gray-700">{{ kit_name[n - 1] }}</td>
              <td class="py-2 px-4">
                <input v-model.number="quantities[n - 1]" type="number" min="0"
                       class="w-20 outline-none border border-gray-300 rounded-lg px-2 py-1 focus:ring-2 focus:ring-blue-400 transition"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- Total Kits -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">Total No Of Kits:</label>
        <input type="number" :value="totalKits" readonly
               class="flex-1 outline-none border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-purple-400 transition"/>
      </div>
      <!-- Delivery Date -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">Delivery Date:</label>
        <input type="date" v-model="DeliveryDate"
               class="flex-1 outline-none border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 transition"/>
      </div>
      <!-- Partial Delivery Allowed -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">Partial Delivery Allowed:</label>
        <div class="flex gap-4">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" value="Yes" v-model="PartialDelivery" id="partial_del_yes" name="partial_del"
                   class="accent-green-500 transition"/>
            <span>Yes</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="radio" value="No" v-model="PartialDelivery" id="partial_del_no" name="partial_del"
                   class="accent-red-500 transition"/>
            <span>No</span>
          </label>
        </div>
      </div>
      <!-- Remarks -->
      <div class="flex flex-col sm:flex-row items-center gap-4">
        <label class="font-semibold text-gray-700 w-48">Remarks:</label>
        <textarea v-model="remarks" rows="2"
                  class="flex-1 outline-none border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-pink-400 transition resize-none"
                  placeholder="Any remarks..."></textarea>
      </div>
      <!-- Buttons -->
      <div class="flex justify-center gap-6 mt-4">
        <button @click="createEnq" type="button"
                class="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold rounded-xl shadow-lg hover:from-blue-600 hover:to-purple-700 hover:scale-105 hover:shadow-2xl transition-all duration-300 animate-fade-in-up"
        >Submit
        </button>
        <button type="button" @click="cancel_button"
                class="px-8 py-3 bg-gradient-to-r from-gray-400 to-gray-600 text-white font-bold rounded-xl shadow-lg hover:from-gray-500 hover:to-gray-700 hover:scale-105 hover:shadow-2xl transition-all duration-300 animate-fade-in-up"
        >Cancel
        </button>

      </div>
    </form>
  </div>
</template>


<script>
import axios from '../axios-setup';
import NavigationBar from "@/components/NavigationBar.vue";

export default {
  name: "CreateEnquiry",
  data() {
    return {
      CustomerName: '',
      DeliveryAddress: '',
      BillingAddress: '',
      PODate: '',
      PaymentRecievedType: '',
      payment_percet: '',
      DeliveryDate: '',
      PartialDelivery: '',
      remarks: '',
      kit_name: ["2P×3, 10°, 6.5 FT", "2P×3, 10°, 8.2 FT", "2P×5, 10°, 6.5 FT", "2P×5, 10°, 8.2 FT", "2P×3, 15°, 6.5 FT", "2P×3, 15°, 8.2 FT", "2P×5, 15°, 6.5 FT", "2P×5, 15°, 8.2 FT"],
      quantities: Array(8).fill(''),
      customerType: 'New', // Default to New
      selectedExistingClient: '',
      allEnquiries: [], // Will store all enquiries from API
    }
  },
  components: {
    NavigationBar
  },
  computed: {
    totalKits() {
      return this.quantities.reduce((sum, val) => sum + (parseInt(val) || 0), 0);
    },
    uniqueClientNames() {
      // Extract client_name from enquiries, filter out null/empty, remove duplicates, and sort
      return this.allEnquiries
          .map(enquiry => enquiry.client_name)
          .filter(name => name && name.trim() !== '')
          .filter((name, index, self) => self.indexOf(name) === index)
          .sort();
    }
  },
  async created() {
    // Fetch all enquiries to extract client names
    try {
      const response = await axios.get('enquiry/?page_size=1000'); // Get more records for client names
      // Handle paginated response - check if response has 'results' field
      if (response.data && response.data.results && Array.isArray(response.data.results)) {
        this.allEnquiries = response.data.results;
      } else if (Array.isArray(response.data)) {
        // Fallback for non-paginated response
        this.allEnquiries = response.data;
      } else {
        console.warn('Unexpected API response format in CreateEnquiry:', response.data);
        this.allEnquiries = [];
      }
    } catch (error) {
      console.error("Error fetching enquiries:", error);
      this.allEnquiries = [];
    }
  },
  methods: {
    async createEnq() {
      // Basic required fields check
      if (
          !this.CustomerName ||
          !this.DeliveryAddress ||
          !this.BillingAddress ||
          !this.PODate ||
          !this.PaymentRecievedType ||
          (this.PaymentRecievedType === 'Partial' && !this.payment_percet) ||
          this.quantities.every(q => !q || q <= 0) ||  // At least one quantity required
          !this.DeliveryDate ||
          !this.PartialDelivery
      ) {
        alert("Please fill in all fields.");
        return;
      }

      try {
        const response = await axios.post('enquiry/', {
          client_name: this.CustomerName,
          delivery_address: this.DeliveryAddress,
          billing_address: this.BillingAddress,
          po_date_str: this.PODate,
          payment_received: this.PaymentRecievedType,
          payment_percentage: this.payment_percet,
          kit1_name: this.kit_name[0],
          kit1_qty: this.quantities[0],
          kit2_name: this.kit_name[1],
          kit2_qty: this.quantities[1],
          kit3_name: this.kit_name[2],
          kit3_qty: this.quantities[2],
          kit4_name: this.kit_name[3],
          kit4_qty: this.quantities[3],
          kit5_name: this.kit_name[4],
          kit5_qty: this.quantities[4],
          kit6_name: this.kit_name[5],
          kit6_qty: this.quantities[5],
          kit7_name: this.kit_name[6],
          kit7_qty: this.quantities[6],
          kit8_name: this.kit_name[7],
          kit8_qty: this.quantities[7],
          total_kits: this.totalKits,
          delivery_date_str: this.DeliveryDate,
          partial_delivery_allowed: this.PartialDelivery,
          remarks: this.remarks,
        });

        console.log("Response:", response.data);

        if (response.status === 201) {
          alert("Sales Order Created");
          this.$router.push({name: 'Home'});
        } else {
          console.error("Unexpected status code:", response.status);
        }
      } catch (error) {
        console.error("Axios error:", error.response || error.message);
      }
    },
    cancel_button() {
      this.$router.push({name: 'Home'});
    },

  },

}
</script>

<style scoped>
.input-animated {
  @apply border border-gray-300 rounded-lg px-3 py-2 transition-all duration-300 outline-none bg-white;
}

.input-animated:hover,
.input-animated:focus {
  @apply scale-105 ring-2 ring-blue-400 shadow-lg bg-white;
}
</style>